import { FiscalYear } from '../entities/fiscalYear';
import { ExecutingUnit } from '../entities/executingUnit';
import { PayrollType } from '../entities/payroll-type';
import { EmployeeType } from '../entities/employeeType';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { CostCenter } from '../entities/costCenter';
import { ReportEmployerContribution } from '../entities/report-employer-contribution';
import { Injector, Injectable } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

interface ExtraSearchFields {
  object?: any;
  fiscalYear?: FiscalYear,
  executingUnit?: ExecutingUnit,
  payrollType?: PayrollType,
  employeeType?: EmployeeType,
  monthBegin?: Hhelpdesk,
  monthEnd?: Hhelpdesk,
  costCenter: CostCenter,
  costCenterActual: CostCenter
}

@Injectable()
export class ReportEmployerContributionService extends BaseReportService<ReportEmployerContribution> {

  public uri = '/api/reportEmployerContribution/';

  constructor(injector: Injector) {
    super(injector);
    ////console.log('Instance ReportCurrentEmployeeDataService');
  }

  buildSentence(entity?: ReportEmployerContribution, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.payrollType ?
          `payrollType.id${QueryOperator.Equal}${extraSearchFields.payrollType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthBegin ?
          `monthBegin.id${QueryOperator.Equal}${extraSearchFields.monthBegin.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthEnd ?
          `monthEnd.id${QueryOperator.Equal}${extraSearchFields.monthEnd.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.costCenterActual ?
          `costCenterActual.id${QueryOperator.Equal}${extraSearchFields.costCenterActual.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      ////console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

//   searchToReport(entity?: ReportCurrentEmployeeData, event?: LazyLoadEvent,
//     extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<ReportCurrentEmployeeData>> {
//      //console.log('searchToReport')
//     const url = `${this.rutaServidor}${this.uri}search`;
//     this.spinnerService.showAll();
//     const httpParams = this.buildSentence(entity, event, extraSearchFields);
//     return this.httpClient.get<ResponsePageable<ReportCurrentEmployeeData>>(url, { params: httpParams })
//       .pipe(
//         tap(response => {
//           if (response.numberOfElements > 0) {
//             response.content.forEach((value) => {
//               // debugger;
//               this.convertToDate(value);
//             })
//           }
//           this.spinnerService.hideAll();
//           return response;
//         })
//       );
//   }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    payrollType: any,
    employeeType: any,
    monthBegin: any,
    monthEnd: any,
    costCenter: any,
    costCenterActual: any,
    object: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('payrollTypeId', payrollType)
        .set('employeeTypeId', employeeType)
        .set('monthBeginId', monthBegin)
        .set('monthEndId', monthEnd)
        .set('costCenterId', costCenter)
        .set('costCenterActualId', costCenterActual)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-employer-contribution.service.ts